import { render, staticRenderFns } from "./DashboardBengkulu.vue?vue&type=template&id=06077eb3&lang=pug"
import script from "./DashboardBengkulu.vue?vue&type=script&lang=js"
export * from "./DashboardBengkulu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports